var render = function render(_c,_vm){return _c('div',[(_vm.props.row[_vm.props.column] && !isNaN(Number(_vm.props.row[_vm.props.column])))?[_c('format',{attrs:{"value":_vm.props.row[_vm.props['column']],"messageTooltip":[
        'message.work_msg_tooltip.displayed_value',
        ':<br />',
        'message.work_msg_tooltip.quantity_x_value_unit',
        '+ <br />',
        'message.work_msg_tooltip.additional_type_hour',
        _vm.props.row.add_increment ? ' + <br /> ' : '',
        _vm.props.row.add_increment
          ? 'message.work_msg_tooltip.quantity_x_increments'
          : '',
      ]}})]:_c('iconwarning')],2)
}
var staticRenderFns = []

export { render, staticRenderFns }